<div class="user-menu">
  <!-- Used by Dynatrace API -->
  <span id="fantaz-username" hidden="true">{{ userName }}</span>
  <button
    *ngIf="isNotZbo"
    mat-flat-button
    color="primary"
    class="become-zbo"
    data-ga-value="navbar-become-zbo"
    (click)="becomeZBO()"
  >
    <img src="/shared/img/profile/zbo-light.webp" alt="" />
    <span class="become-zbo-text text"> Become ZBO </span>
  </button>
  <a
    *ngIf="currentUser"
    mat-button
    class="promote-code"
    [ngClass]="{ zbo: isNotZbo }"
    data-ga-value="navbar-promote-code"
    (click)="onPromoteCode()"
  >
    <mat-icon class="material-icons-outlined"> sell </mat-icon>
    <span class="text"> <span>PROMO CODE</span> </span>
  </a>
  <a
    mat-button
    class="account-balance"
    href="/wallet"
    *ngIf="isLoggedIn"
    data-ga-value="navbar-link-wallet"
  >
    <mat-icon class="material-icons-outlined">
      account_balance_wallet
    </mat-icon>
    <span class="wallet-key">
      <span>{{ wallet?.balance || 0 | fzCurrency }}</span>
    </span>
  </a>

  @if (currentUser) {
    <fz-notification-center [theme]="theme" [subscriberId]="userUuid">
    </fz-notification-center>
  }

  <div>
    @if (isLoggedIn) {
      <button
        mat-button
        [matMenuTriggerFor]="menu"
        aria-label="Menu"
        data-ga-value="navbar-menu"
        class="menu-btn-text"
      >
        <span class="">Menu</span>
        <mat-icon iconPositionEnd>keyboard_arrow_down</mat-icon>
      </button>
    }

    <button
      mat-icon-button
      [matMenuTriggerFor]="menu"
      aria-label="Menu"
      (click)="onMenuButtonPressed()"
      class="menu-btn-icon"
    >
      <mat-icon>{{ menuIconValue }}</mat-icon>
    </button>

    <mat-menu
      #menu="matMenu"
      id="userMenu"
      backdropClass="user-menu"
      (closed)="onMenuClosed()"
    >
      @if (isLoggedIn) {
        <div class="username-ctn">
          <img [src]="userAvatarUrl" alt="username" />
          <span class="username -semibold">
            {{ userName }}
          </span>
          @if (isBizAccount) {
            <span class="biz-account-tag ml--1">Business</span>
          }
        </div>
      }
      <mat-divider *ngIf="isLoggedIn"></mat-divider>
      <!-- Extra nav -->
      <div *ngIf="isLoggedIn" class="wallet-icon-ctn">
        <mat-accordion class="user-menu__accordion">
          <mat-expansion-panel
            class="mat-elevation-z0"
            (click)="onPanelClick($event)"
            [expanded]="openPanelState.wallet"
            (opened)="setOpenPanel('wallet', true)"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon class="material-icons-outlined"
                  >account_balance_wallet</mat-icon
                >
                <span class="no-margin"
                  >Z-Wallet:
                  <span class="primary-color"
                    ><fz-currency [value]="wallet?.balance"></fz-currency
                  ></span>
                </span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <a
              mat-menu-item
              href="/wallet/deposit"
              data-ga-value="navbar-link-wallet-deposit"
            >
              Deposit
            </a>
            <a
              mat-menu-item
              href="/wallet/withdraw"
              data-ga-value="navbar-link-wallet-withdraw"
            >
              Withdraw
            </a>
            <a
              mat-menu-item
              href="/wallet/history"
              data-ga-value="navbar-link-wallet-history"
            >
              History
            </a>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
      <mat-divider *ngIf="isLoggedIn"></mat-divider>
      <mat-accordion class="user-menu__accordion">
        <mat-expansion-panel
          class="mat-elevation-z0"
          (click)="onPanelClick($event)"
          [expanded]="openPanelState.play"
          (opened)="setOpenPanel('play', true)"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon class="material-icons-outlined"
                >sports_esports</mat-icon
              >
              <span class="no-margin">Play</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <a mat-menu-item href="/games" data-ga-value="navbar-link-games">
            Games
          </a>
          <a
            mat-menu-item
            href="/tournaments"
            data-ga-value="navbar-link-tournaments-cash"
          >
            Tournaments
          </a>
        </mat-expansion-panel>
      </mat-accordion>

      <a
        class="navbar-link"
        mat-menu-item
        (click)="onPromote()"
        data-ga-value="navbar-link-promote"
      >
        <mat-icon class="material-icons-outlined">share</mat-icon>
        <span>Promote</span>
      </a>
      <a
        class="navbar-link"
        mat-menu-item
        href="/profit"
        data-ga-value="navbar-link-profit"
      >
        <mat-icon class="material-icons-outlined">show_chart</mat-icon>
        <span>Profit</span>
      </a>

      <mat-divider class="mobile-divider" *ngIf="isLoggedIn"></mat-divider>
      <mat-accordion *ngIf="isLoggedIn" class="user-menu__accordion">
        <mat-expansion-panel
          class="mat-elevation-z0"
          (click)="onPanelClick($event)"
          [expanded]="openPanelState.profile"
          (opened)="setOpenPanel('profile', true)"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon class="material-icons-outlined">storefront</mat-icon>
              <span class="no-margin">My Profile</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-container *ngFor="let item of profileSubmenu">
            <a
              mat-menu-item
              href="{{ item.link }}"
              attr.data-ga-value="navbar-link{{ item.link.replace('/', '-') }}"
            >
              {{ item.label }}
            </a>
          </ng-container>
        </mat-expansion-panel>
      </mat-accordion>
      <a
        *ngIf="isLoggedIn"
        mat-menu-item
        [href]="'/tournaments/gamehistory'"
        data-ga-value="navbar-link-game-history"
      >
        <mat-icon class="material-icons-outlined">history</mat-icon>
        <span>Game History</span>
      </a>
      <a
        class="navbar-link"
        href="https://fantaz.zendesk.com/hc/en-us"
        target="_blank"
        mat-menu-item
        data-ga-value="navbar-link-news"
      >
        <mat-icon class="material-icons-outlined">contact_support</mat-icon>
        <span>News & FAQs</span>
      </a>
      <mat-divider></mat-divider>
      <a
        *ngIf="enableSwitchTheme"
        mat-menu-item
        data-ga-value="navbar-link-change-theme"
        class="theme-mode-menu-container"
      >
        <div class="theme-mode-menu-item">
          <mat-icon class="material-icons-outlined">dark_mode</mat-icon>
          <span>Dark Theme</span>
          <fz-color-scheme-switcher
            *ngIf="enableSwitchTheme"
            (toggleChange)="onThemeChange($event)"
            [slideToggle]="true"
          ></fz-color-scheme-switcher>
        </div>
      </a>
      <mat-divider></mat-divider>
      <a
        *ngIf="isLoggedIn"
        mat-menu-item
        (click)="onLogoutPress()"
        data-ga-value="navbar-link-Logout"
      >
        <mat-icon class="material-icons-outlined">logout</mat-icon>
        <span>Logout</span>
      </a>
      <a
        *ngIf="!isLoggedIn"
        mat-menu-item
        (click)="onLogin()"
        data-ga-value="navbar-link-login"
      >
        <mat-icon class="material-icons-outlined">login</mat-icon>
        <span>Login</span></a
      >
    </mat-menu>
  </div>
</div>
